module.exports = __webpack_public_path__ + "img/energy_2.9ae0d899.png";